import {createAction} from "@reduxjs/toolkit";

export const addressSearch = createAction('address/search')
export const addressSearchSuccess = createAction('address/search/success')
export const addressSearchFailure = createAction('address/search/failure')
export const addressSelect = createAction('address/select')